import { Button as ButtonBase } from '@mui/material';
import { useButtonStyles } from 'components/common/Button/styles';

export const Button = ({ children, className, color, variant, ...props }) => {
  const { classes } = useButtonStyles();
  const customClass = classes[`${color}-${variant}`];
  const buttonClass = `${customClass || ''} ${className || ''}`;

  return (
    <ButtonBase
      {...props}
      className={buttonClass}
      variant={variant}
      color={customClass ? 'default' : color}
    >
      {children}
    </ButtonBase>
  );
};
